
import { defineComponent, onMounted, ref } from "vue";
import { useI18n } from "vue-i18n/index";
import moment from "moment";
import Datatable from "@/components/kt-datatable/KTDatatable.vue";
import DateRangePicker from "@/components/DateRangePicker.vue";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import ApiService from "@/core/services/ApiService";

interface ILoginHistory {
  agent_id: string;
  code: string;
  agent: string;
  ip_address: string;
  createdAt: string;
}

interface DateRange {
  start: string;
  end: string;
}

export default defineComponent({
  name: "LoginHistory",
  components: {
    Datatable,
    DateRangePicker,
  },
  setup(props, { emit }) {
    // vue variables
    const { t } = useI18n();
    // table headers
    const tableHeader = ref([
      {
        name: t("Agents.Name"),
        key: "agent",
        text: true,
      },
      {
        name: t("LoginHistory.IP"),
        key: "ip_address",
        text: true,
      },
      {
        name: t("LoginHistory.Date"),
        key: "createdAt",
        text: true,
      },
      {
        name: t("LoginHistory.Block"),
        key: "block",
        customslot: true,
      },
    ]);
    const tableData = ref<Array<ILoginHistory>>([]);
    /**
     * Get Histories
     *
     */
    const getHistories = async (daterange: DateRange) => {
      const logs: ILoginHistory[] = await ApiService.get(
        `/agent/login/histories?start=${daterange.start}&end=${daterange.end}`
      )
        .then((res) => res.data)
        .catch(() => []);
      tableData.value.splice(0, tableData.value.length, ...logs);
    };
    /**
     * Block IP
     *
     */
    const blockIP = async (history: ILoginHistory) => {
      Swal.fire({
        title: history.ip_address + " " + t("LoginHistory.Block"),
        text: t("LoginHistory.BlockMessage"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: t("LoginHistory.Confirm"),
        cancelButtonText: t("LoginHistory.Cancel"),
      }).then((result) => {
        if (result.isConfirmed) {
          ApiService.post("/agent/login/block-unblock", {
            agent_id: history.agent_id,
            ip_address: history.ip_address,
            action: "BLOCK",
          })
            .then(() => {
              Swal.fire(
                t("LoginHistory.Block"),
                t("LoginHistory.BlockSuccess"),
                "success"
              );
              emit("refresh");
            })
            .catch(() => {
              Swal.fire(
                t("LoginHistory.Block"),
                t("LoginHistory.BlockFailed"),
                "error"
              );
              emit("refresh");
            });
        }
      });
    };
    /**
     * On Mounted
     *
     */
    onMounted(() =>
      // get Histories
      getHistories({
        start: moment().format("YYYY-MM-DD"),
        end: moment().format("YYYY-MM-DD"),
      })
    );
    return {
      tableHeader,
      tableData,
      getHistories,
      blockIP,
    };
  },
});
